export const POSTHOG_EVENTS = {
    LEAD_CREATED: 'lead_created',
    JOB_CREATED: 'job_created',
    SCHEDULE_TASK_CREATED: 'schedule_task_created',
    ICR_STAGE_CREATED: 'icr_stage_created',
    ICR_STAGE_UPDATED: 'icr_stage_updated',
    ICR_STAGE_SIGNED_OFF: 'icr_stage_signed_off',
    QUOTE_CREATED: 'quote_created',
} as const;

export type PosthogEventName = (typeof POSTHOG_EVENTS)[keyof typeof POSTHOG_EVENTS];
